import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Slider from "../Slider";
import CustomModal from "./CustomModal";
import { investCampaign, getCampaigns } from "../../redux/actions/web3Actions";
import { useDispatch, useSelector } from "react-redux";
import { useWeb3React } from "@web3-react/core";
import Snackbar from "../Misc/Snackbar.js";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "4rem",
    background: "#FFFFFF",
    overflow: "scroll",
    overflowX: "hidden",
    boxShadow: "0px 4px 12px rgba(34, 43, 69, 0.06)",
    borderRadius: "8px",
    height: "50rem",
    width: "70rem",
  },

  modalHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "3rem",
  },

  poolLabel: {
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.1rem",
    marginRight: "1.6rem",
  },
  bold: {
    fontWeight: "700",
  },
  bold2: {
    fontWeight: "700",
    marginLeft: "1rem",
  },
  dot: {
    height: "6px",
    width: "6px",
    backgroundColor: "black",
    borderRadius: "100%",
    marginRight: "5px",
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  flex2: {
    display: "flex",
    // alignItems: "center",
  },

  poolLabelValue: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2.1rem",
  },

  poolDetailRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1.6rem",
  },

  poolDetailCol: {
    display: "flex",

    flexDirection: "column",
    marginBottom: "2.4rem",
  },

  poolDetailColValue: {
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
  },
  poolDetailColValueBold: {
    fontWeight: "600",
    fontSize: "1.8rem",
    lineHeight: "2.4rem",
  },
  poolDetailsBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  poolDetailsAround: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
  btn: {
    fontWeight: "600",
    width: "13rem",
    fontSize: "1.4rem",
  },
}));

const ProjectBriefModal = ({ showModal, setShowModal, modalData }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  console.log("MODAL", modalData);

  // const allCampaignData = useSelector((state) => state.ui.allCampaignData);
  // console.log("allCampaignData inside MODAL ===> ", allCampaignData);

  // const isUser = useSelector((state) => state.ui.isUser);
  // console.log("claimableId by kol ninside MODAL ========", isUser.kol);

  return (
    <CustomModal showModal={showModal} setShowModal={setShowModal}>
      {/* <Snackbar open={open} setOpen={setOpen} /> */}
      <Box className={classes.container}>
        <Typography className={classes.modalHeading}>
          Campaign Details
        </Typography>

        <Box className={classes.poolDetailRow}>
          <Typography className={classes.poolLabel}>campaign Name:</Typography>
          <Typography className={classes.poolLabelValue}>
            {modalData?.campaignName}
          </Typography>
        </Box>

        <Box className={classes.poolDetailRow}>
          <Typography className={classes.poolLabel}>Project Name:</Typography>
          <Typography className={classes.poolLabelValue}>
            {modalData?.projectName}
          </Typography>
        </Box>

        <Box className={classes.poolDetailRow}>
          <Typography className={classes.poolLabel}>Keywords:</Typography>
          <Typography className={classes.poolLabelValue}>
            {modalData?.keyword}
          </Typography>
        </Box>
      </Box>
    </CustomModal>
  );
};

export default ProjectBriefModal;
